export const TERMS_LATEST = 'TERMS_LATEST';
export const TERMS_ALL = 'TERMS_ALL';
export const TERMS_SAVE = 'TERMS_SAVE';
export const TERMS_ACCEPTED = 'TERMS_ACCEPTED';
export const TERMS_MUST_ACCEPT = 'TERMS_MUST_ACCEPT';
